export default "__VITE_ASSET__fbc208dc__"